import { useEffect } from 'react'

const RETRY_INTERVAL_MS = 150
const MAX_ATTEMPTS = 20

export const useAsyncApiScroll = (ref: HTMLDivElement | undefined, hash: string) => {
  useEffect(() => {
    if (!ref || !hash) { 
      return 
    }

    const operation = hash.split('/').pop() || ''
    let attempts = 0
    let timeoutId: NodeJS.Timeout

    const tryScroll = () => {
      const section = ref.querySelector(`[id*="${operation}"]`) as HTMLElement | null
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' })
        return
      }
      if (attempts < MAX_ATTEMPTS) {
        attempts++
        timeoutId = setTimeout(tryScroll, RETRY_INTERVAL_MS)
      }
    }

    timeoutId = setTimeout(tryScroll, RETRY_INTERVAL_MS)

    return () => clearTimeout(timeoutId)
  }, [hash, ref])
}